<script setup lang="ts">
const { t } = useI18n()

const emit = defineEmits<{
  (e: 'click'): void
}>()

const onClick = () => {
  emit('click')
}
</script>

<template>
  <button
    type="button"
    class="normalize-style tw-group tw-relative tw-flex tw-w-full tw-flex-col tw-overflow-hidden tw-rounded-lg"
    @click="onClick"
  >
    <img
      src="/images/ai-image-card-bg.png"
      alt=""
      aria-hidden="true"
      class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover tw-object-top tw-brightness-50 tw-grayscale-[40%]"
    />

    <div
      class="tw-absolute tw-inset-0 tw-transition-colors tw-duration-200 group-hover:tw-bg-black/20"
    />

    <div
      class="tw-relative tw-flex tw-flex-1 tw-flex-col tw-items-center tw-gap-2 tw-px-4 tw-py-8 tw-text-center"
    >
      <IconsAiSparkle class="tw-h-8 tw-w-8 tw-shrink-0" />

      <p class="tw-text-lg tw-font-bold tw-text-white tw-drop-shadow-md">
        {{ t('ai_image_banner_title') }}
      </p>

      <p class="tw-text-sm tw-text-white/80">
        {{ t('ai_image_banner_body') }}
      </p>

      <span
        class="tw-mt-auto tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-bg-gradient-to-r tw-from-riser-blue tw-via-riser-green tw-to-riser-yellow tw-px-6 tw-py-2 tw-text-sm tw-font-bold tw-text-white"
      >
        {{ t('ai_image_banner_title') }}
      </span>
    </div>
  </button>
</template>
